import axios from "axios";
import {
  addFailureNotification,
  addSuccessNotification,
  getServiceErrorMessage,
} from "../../shell/notification/notifications";
import { Get } from "../../api/request";
import { withQuery } from "../../api/query";

const API = window.location.origin + "/api/";

function postAutomationRequest(
  dispatch,
  method,
  payload,
  successMessage
) {
  return axios
    .post(API + method, payload)
    .then(function (response) {
      if (successMessage) {
        addSuccessNotification(dispatch, successMessage);
      }

      return response;
    })
    .catch(function (error) {
      console.log(error);
      if (dispatch) {
        addFailureNotification(dispatch, getServiceErrorMessage(error));
      }

      return error;
    });
}

export function GetAutomationDashboardMetrics(dispatch, recentRunStatus) {
  return Get(
    dispatch,
    withQuery("automation/dashboard-metrics", {
      recentRunStatus: recentRunStatus || undefined,
    })
  );
}

export function GetAutomationFixtureReadiness(dispatch, fixtureId) {
  return Get(
    dispatch,
    withQuery("automation/fixture-readiness", { fixtureId })
  );
}

/** The fixture page's readiness cards, as related-table rows. */
export function GetAutomationFixtureReadinessRows(dispatch, fixtureId) {
  return Get(
    dispatch,
    withQuery("automation/fixture-readiness", { fixtureId, shape: "rows" })
  );
}

export function GetAutomationExecutions(
  dispatch,
  automationId
) {
  return Get(
    dispatch,
    withQuery("automation/executions", { automationId })
  );
}

export function PrepareAutomationFixture(
  dispatch,
  fixtureId,
  automationId
) {
  return postAutomationRequest(
    dispatch,
    withQuery("automation/fixture/prepare", { fixtureId, automationId }),
    {},
    "Automation communication content prepared"
  );
}

export function CancelAutomationExecution(dispatch, executionId) {
  return postAutomationRequest(
    dispatch,
    withQuery("automation/execution/cancel", { executionId }),
    {},
    "Automation execution cancelled"
  );
}

export function SendAutomationExecutionNow(dispatch, executionId) {
  return postAutomationRequest(
    dispatch,
    withQuery("automation/execution/send-now", { executionId }),
    {},
    "Automation execution send time updated"
  );
}

export function SetAutomationStatus(
  dispatch,
  id,
  status,
  successMessage
) {
  return postAutomationRequest(
    dispatch,
    withQuery("automation/status", { id }),
    { status },
    successMessage
  );
}

export function GetAutomationJourneyPlanner(dispatch) {
  return Get(dispatch, "automation/journey-planner");
}

export function SaveAutomationJourneyPlanner(dispatch, payload) {
  return postAutomationRequest(
    dispatch,
    "automation/journey-planner/save",
    payload,
    "Journey planner saved"
  );
}
